// export const convertPersianToEnglish = (str: string): string => {
//     const persianNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
//     const englishNumbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

//     let result = str;
//     persianNumbers.forEach((persian, index) => {
//         result = result.replace(new RegExp(persian, 'g'), englishNumbers[index]);
//     });
//     return result;
// };

export const convertPersianToEnglish = (str: string): string => {
    return str
        .replace(/[۰-۹]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d).toString())
        .replace(/[٠-٩]/g, (d) => '٠١٢٣٤٥٦٧٨٩'.indexOf(d).toString());
};

export const formatPrice = (value: string): string => {
    // Remove all non-digits
    const numbers = value.replace(/[^\d]/g, '');
    // Add thousand separators
    return numbers.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

